import React from "react";
import "./About.css";
import aboutImage from "../assets/real-estate-saudi-arabia-home-keychain-with-saudi-arabian-flag-property-rent-mortgage-concept-3d-rendering_823159-14307.avif"; // Replace with actual image path
import flageThumbnail from "../assets/thumbnail_real_estate.jpg"; // Replace with video thumbnail
import leaderImage from "../assets/Screenshot_20250303_150345.jpg"; // Replace with actual leader image
import Footer from "./Footer";
const About = () => {
  return (
    <>
    <div className="about-wrapper">
      {/* About JLL Section */}
      <div className="about-container">
        <div className="about-text">
          <h1>نبذة عن عقاري</h1>
          <p>
          نرى طريقا أكثر إشراقا<sup>SM</sup> نتطلع إلى الأمام لعملائنا، وموظفينا، وكوكبنا، ومجتمعاتنا. من خلال الجمع بين التكنولوجيا المبتكرة والخبرة العالمية المرموقة، نكشف عن فرصٍ تُسهم في بناء مستقبلٍ أكثر إشراقًا للجميع.
          </p>
        </div>
       <div className="about-image">
          <img src={aboutImage} alt="Office view" />
        </div>
      </div>

      {/* Additional Section */}
      <div className="additional-container">
        <div className="additional-text">
          <h1>
            <strong>أ</strong>ت عقاري, نحن نفخر بفعل الأشياء بشكل مختلف.
          </h1>
          <p>
          نرى في البيئة المبنية وسيلةً فعّالة لتغيير العالم نحو الأفضل. ومن خلال الجمع بين التكنولوجيا المبتكرة وذكاء البيانات وخبرتنا العالمية المرموقة، نتمكن من كشف فرص النجاح غير المستغلة.
          </p>
          <p>
          نساعد في شراء وبناء وشغل والاستثمار في مجموعة متنوعة من الأصول، بما في ذلك العقارات الصناعية والتجارية وعقارات التجزئة والعقارات السكنية والفندقية. من الشركات الناشئة في مجال التكنولوجيا إلى الشركات العالمية، يمتد عملاؤنا إلى قطاعات تشمل البنوك والطاقة والرعاية الصحية والقانون وعلوم الحياة والتصنيع والتكنولوجيا.
          </p>
          <button className="red-button">Say hello</button>
        </div>
      </div>

      {/* SEE A BRIGHTER WAY Section */}
      <div className="brighter-way-container">
        <div className="video-section">
          <img src={flageThumbnail} alt="flage Thumbnail" className="video-thumbnail" />
          
        </div>
        <div className="brighter-way-text">
          <h1>رؤية طريق أكثر إشراقا</h1>
          <p>
          هناك الطريقة التقليدية للقيام بالأشياء. ثم هناك طريقة أكاري. طريقة أكثر ابتكارًا وذكاءً وإنسانية. اكتشف كيف يمكنك رؤية طريق أكثر إشراقًا مع أكاري.
          </p>
        </div>
      </div>

      {/* Meet Our Leaders Section */}
      <div className="leaders-container">
        <div className="leaders-text">
          <h1>تعرف على قادتنا</h1>
          <p>
          موظفونا هم من يصنعون الفارق. تعرّف على قادة أكاري الذين يساعدون عملاءنا على رؤية طريقٍ أكثر إشراقًا.
          </p>
          <a href="/CEO-CV.pdf" target="_blank" download>
  <button className="red-button">تعرف على قادتنا</button>
</a>

        </div>
        <div className="leaders-image">
          <img src={leaderImage} alt="akari Leader" />
        </div>
      </div>

      {/* Final Statement */}
      <div className="teamwork-text">
        <p><strong>نحن نؤمن بالعمل الجماعي، ونتشارك من أجل النجاح.</strong></p>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default About;
